class CmsInsurance {
  showInCheckoutPage: boolean;

  shortDescription: string;

  bulletPoints?: Array<string>;

  insuranceAddedInCheckoutText: string;

  priceInformation: string;
}

export default CmsInsurance;
